import { Typography } from '@navi/web-ui/lib/primitives';
import { IRequestTitle } from '../../types';

const RequestTitle = (props: IRequestTitle) => {
  const { title, icon } = props;
  return (
    <div className="flex items-center gap-2 pb-2 px-2">
      {icon}
      <Typography variant="h3" color="var(--navi-color-gray-c1)">
        {title}
      </Typography>
    </div>
  );
};

export default RequestTitle;
